import { createSelector } from 'reselect';

const getSceneDataLinks = (state) => state.sceneConfiguration.dataLinks;

const getLinksData = createSelector([getSceneDataLinks], (links) => links);

export default getLinksData;
